import { Form } from 'antd';
import { FC, memo, useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

import { AppMessage } from '@/common/components';
import { ApiRoutes, AppRoutes, FormFieldsErrors } from '@/common/interfaces';
import { extractFormErrors, messageOnError } from '@/common/utils';

import { SearchConsoleAccountsFormSecondStepFields, SearchConsoleAccountsFormSecondStepInputs, useAddCredsSearchConsoleAccountsMutation } from '@/modules/DomainsApi';

import { SecondStepView } from './SecondStepView';
import { searchConsoleAccountsFormSecondStepValidationSchema } from './validations';

interface Props {
  searchConsoleAccountId: string;
}

export const SecondStepCreateContainer: FC<Props> = memo(({ searchConsoleAccountId }) => {
  const navigate = useNavigate();
  const appMessageApi = AppMessage.useControls();

  const [form] = Form.useForm<SearchConsoleAccountsFormSecondStepFields>();
  const [formErrors, setFormErrors] =
    useState<FormFieldsErrors<typeof SearchConsoleAccountsFormSecondStepInputs>>(null);

  const { mutate: addCredentialsMutation, isLoading: credentialsIsLoading } =
    useAddCredsSearchConsoleAccountsMutation(searchConsoleAccountId ?? '')({
      onSuccess: (data) => {
        appMessageApi.success('Облікові дані додано!');

        navigate(AppRoutes.DomainsApiSearchConsoleAccountsCreateOauth2.replace(':searchConsoleAccountId', data.id));
      },
      onError: (err) => {
        setFormErrors(extractFormErrors<typeof SearchConsoleAccountsFormSecondStepInputs>(err));
        messageOnError(err, appMessageApi);
      }
    });

  const initialValues: SearchConsoleAccountsFormSecondStepFields = {
    clientId: undefined,
    clientSecret: undefined
  };

  const handleFinish = useCallback((values: SearchConsoleAccountsFormSecondStepFields): void => {
    setFormErrors(null);
    addCredentialsMutation(values);
  }, []);

  const handleFinishFailed = useCallback((): void => {
    setFormErrors(null);
  }, []);

  const handleBack = useCallback((): void => {
    navigate(ApiRoutes.DomainsApiSearchConsoleAccounts);
  }, []);

  return (
    <>
      <SecondStepView
        formName={ 'create-search-console-account-form-second-step' }
        formType={ 'create' }
        form={ form }
        initialValues={ initialValues }
        formErrors={ formErrors }
        isFormLoading={ credentialsIsLoading }
        validationSchema={ searchConsoleAccountsFormSecondStepValidationSchema }
        handleBack={ handleBack }
        handleFinish={ handleFinish }
        handleFinishFailed={ handleFinishFailed }
      />
    </>
  );
});
